<section [@fadeInDown]>
  <div class="base-container">
    <div class="row">
      <app-back-button></app-back-button>
    </div>
    <app-forgot-user-form></app-forgot-user-form>
  </div>
</section>
